import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from 'app/Services/login.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserActionTypeLabel } from 'app/Model/Dto/UserLog/UserLogEntry';
import { TranslateCatalog } from 'app/Model/Dto/TranslateCatalog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'user-log',
    templateUrl: './user-log.component.html',
    styleUrls: ['./user-log.component.css'],
    standalone: false
})
export class UserLogComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: true }) dataGrid: DxDataGridComponent;

  userLogs: any;

  constructor(
    public loginService: LoginService,
    public authService: OAuthService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.setupDataSource();
  }

  setupDataSource(): void{
    const accessToken = this.authService.getAccessToken();

    this.userLogs = AspNetData.createStore({
    key: 'id',
    loadUrl: '/api/UserLog/GetUserLogs',
    loadParams: {
      customerId: this.loginService.currentCustomer.id
    },
    onBeforeSend(method, ajaxOptions) {
      (ajaxOptions.xhrFields = { withCredentials: true }),
        (ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        });
    },
    onLoaded: (data) => {
        data.forEach((log) => {
        log.userActionDisplay = UserActionTypeLabel[log.userAction];
      });
      return data;
    }
  });
  }

  reload(): void {
    this.dataGrid?.instance?.refresh();
  }

  onGridToolbarPreparing(e: any): void {
    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'refreshButtonTemplate'
    });

    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'minGroupsButtonTemplate',
    });

    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'maxGroupsButtonTemplate',
    });
  }

  onExporting(e: any): void {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('UserLogs');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'UserLogs.xlsx');
      });
    });

    e.cancel = true;
  }
}
